import { UpdateAdminType } from 'domain/usecases/update-admin-type';
import { BaseHttpService } from 'main/factories/http';

export class RemoteUpdateAdminType extends BaseHttpService<UpdateAdminType.Model> implements UpdateAdminType {
  async updateAdminType(params: UpdateAdminType.Params): Promise<UpdateAdminType.Model> {
    const payload = {
      userId: params.userId,
      adminType: params.adminType,
    };

    return await this.request('post', payload);
  }
}
